import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { news } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];
const freshList = allNews.filter((item) => item.isFresh).slice(0, 4);

export default function FreshGrid() {
  return (
    <section id="fresh" className="w-full scroll-mt-20 bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="JUST IN"
          title="刚刚发生"
          desc="只保留最近几小时的最新动态。不想错过任何一条新瓜的蹲点网友，从这里开始看就够了。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-2 rounded-md border border-background-400/70 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多新瓜
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          }
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {freshList.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}